import { createStore, getValue, update } from '@kundinos/nanostores';
import { useStore } from '@kundinos/nanostores/react';

import type { ConstructorValueData } from '@Pages/PageProduct';

export const selectedParamsStore = createStore<ConstructorValueData[]>(() => {
  selectedParamsStore.set([]);
});

export const activeMobilePanelStore = createStore<boolean>(() => {
  activeMobilePanelStore.set(false);
});

export const set = (items: ConstructorValueData[]) => {
  const value = getValue(selectedParamsStore);
  if (value.length > 0) return;

  update(selectedParamsStore, () => items);
};

export const updateStore = (items: ConstructorValueData[]) => {
  update(selectedParamsStore, () => items);
};

export const change = (item: ConstructorValueData) => {
  update(selectedParamsStore, (prev) => {
    const existingIndex = prev.findIndex((pv) => pv.parameterIds[0] === item.parameterIds[0]);

    if (existingIndex === -1) {
      return [...prev, item];
    }

    const updatedParams = [...prev];
    updatedParams[existingIndex] = item;
    return updatedParams;
  });
};

export const changePanelView = (val: boolean) => {
  update(activeMobilePanelStore, () => val);
};

export const useSelectedParams = () => {
  return useStore(selectedParamsStore);
};

export const useActiveMobilePanel = () => {
  return useStore(activeMobilePanelStore);
};
